import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRadium, SearchParams, gtmEvent } from 'higher-order-components'
import { FORM_ERRORS } from 'constants/errors'
import { WysiwygContent, InputText, TickModalIcon, Button, Heading } from 'components'
import { get, paramsFromLocation, PLACEHOLDER as _ } from 'utils'
import {
  validatePassword,
  lengthCheck,
  hasLowerUpperCase,
  hasNumber,
  hasSymbol,
  required
} from 'utils/validation'
// Redux
import { gtmMyMazda2ActionTypes } from 'store/gtm-events'

import Form from 'components/forms'
import FormSection from '../../form-section'
import SubmitSection from '../../submit-section'

export class MyMazdaPassword extends Form {
  constructor(props) {
    super(props)

    this.state = {
      displayThankYou: false,
      fields: {
        password: '',
        confirmPassword: ''
      }
    }
  }

  submitMapping = (fields = {}) => {
    const getVal = get(_, fields)
    const queryParams = paramsFromLocation(location)

    return {
      email: queryParams.email,
      guid: queryParams.token,
      password: getVal('password.value')
    }
  }

  render() {
    const { displayThankYou, fields } = this.state
    const {
      accountActivationApiEndpoint,
      heading,
      successfulPageUrl,
      passswordUpdateSuccessfulText,
      passwordInputLabel
    } = this.props

    const toMyMazdaButtonText = "Login to MyMazda"

    if (displayThankYou) {
      return (
        <div style={styles.container}>
          <div style={[...styles.content, { justifyContent: 'center', textAlign: 'center' }]}>
            <TickModalIcon style={{ width: '2.25em', height: '2.25em', margin: '0 auto 1em' }} />
            <Heading
              value={'New password created'}
              customHeadingStyle={styles.heading}
              textAlign="center"
            />
            <WysiwygContent xmlString={passswordUpdateSuccessfulText} theme={'light'} />
            <Button
              gtmEvents={[createGtmAction.continueToMyMazda({ ...this.props, buttonText: toMyMazdaButtonText })]}
              type="a"
              href={successfulPageUrl}
              label={toMyMazdaButtonText}
              styleName="black"
            />
          </div>
        </div>
      )
    }

    return (
      <div data-test="mymazda-password-form">
        <div style={styles.container}>
          <div style={styles.content}>
            <Heading tag="h2" size="large" value={heading} customHeadingStyle={styles.heading} />
            <PasswordSection
              fields={fields}
              passwordInputLabel={passwordInputLabel}
              linkState={this.linkState}
              gtmEvent={this.props.gtmEvent}
            />

            <SubmitSection
              buttonText={this.props.buttonText}
              onSubmit={() => {
                this.submit(accountActivationApiEndpoint, this.state.fields, this.submitMapping, {
                  credentials: 'same-origin'
                })
              }}
              canSubmit={this.canSubmit()}
              errorMessages={[this.state.errorMessages, this.state.error]}
              submitting={this.state.submitting}
              gtmEvents={[createGtmAction.createPassword(this.props)]}
            />
          </div>
        </div>
      </div>
    )
  }
}


const createGtmAction = {
  createPassword: ({ gtmEvent, buttonText }) => ({
    func: gtmEvent,
    args: [
      {
        gtmID: gtmMyMazda2ActionTypes.CREATE_PASSWORD,
        gtmPayload: {
          buttonText
        }
      }
    ]
  }),
  continueToMyMazda: ({ gtmEvent, buttonText }) => ({
    func: gtmEvent,
    args: [
      {
        gtmID: gtmMyMazda2ActionTypes.CONTINUE_TO_MYMAZDA,
        gtmPayload: {
          buttonText
        }
      }
    ]
  })
}

MyMazdaPassword.propTypes = {
  accountActivationApiEndpoint: PropTypes.string.isRequired,
  thankYouComponents: PropTypes.array,
  buttonText: PropTypes.string,
  // GTM actions
  gtmClickGoBack: PropTypes.func,
  gtmClickSubmit: PropTypes.func,
  gtmEnterEmail: PropTypes.func
}

MyMazdaPassword.defaultProps = {
  buttonText: 'Register account'
}

export class PasswordSection extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showPassword: false,
      showConfirmPassword: false
    }
  }

  togglePassword(key) {
    this.setState({
      [key]: !this.state[key]
    })
  }

  passwordStrengthIndicator() {
    const { fields } = this.props
    const icon = (
      <TickModalIcon style={{ width: '18px', height: '18px', float: 'left', margin: '1px 0.5em 0 0' }} />
    )
    const invalid = (
      <span
        style={{
          width: '1em',
          height: '1em',
          margin: '1px 0.5em 0 0',
          border: '2px solid #D8D8D8',
          borderRadius: '50%',
          float: 'left'
        }}
      />
    )
    const style = { lineHeight: '20px', color: '#191919' }
    const val = get('password.value', fields)

    return (
      <div style={{ fontSize: '0.875em' }}>
        <WysiwygContent
          xmlString={'<p style="margin-bottom: 0;">Please select a password that has</p>'}
          theme={'light'}
        />
        <p style={style}>{lengthCheck(val, 8, 20) ? icon : invalid} 8-20 characters.</p>
        <p style={style}>{hasLowerUpperCase(val) ? icon : invalid} Upper and lowercase letters.</p>
        <p style={style}>
          {hasNumber(val) || hasSymbol(val) ? icon : invalid} One number or one symbol.
        </p>
      </div>
    )
  }

  passwordMatch(value) {
    const { fields } = this.props
    let isValid = true
    let message

    if (value !== get('password.value', fields)) {
      isValid = false
      message = 'Password does not match'
    }

    return {
      status: {
        modifiedValue: value,
        isValid,
        message
      }
    }
  }

  render() {
    const { showPassword, showConfirmPassword } = this.state
    const { fields, passwordInputLabel } = this.props

    return (
      <div>
        {this.passwordStrengthIndicator()}

        <FormSection marginTop={'0'}>
          <InputText
            label={passwordInputLabel}
            type={showPassword ? 'text' : 'password'}
            icon={'eye'}
            iconText={showPassword ? 'Hide' : 'Show'}
            onIconClick={this.togglePassword.bind(this, 'showPassword')}
            {...this.props.linkState(
              'password',
              required(validatePassword, FORM_ERRORS.PASSWORD_REQUIRED)
            )}
          />

          <InputText
            label={'Confirm password'}
            type={showConfirmPassword ? 'text' : 'password'}
            icon={'eye'}
            iconText={showConfirmPassword ? 'Hide' : 'Show'}
            onIconClick={this.togglePassword.bind(this, 'showConfirmPassword')}
            {...this.props.linkState(
              'confirmPassword',
              required(this.passwordMatch.bind(this), FORM_ERRORS.PASSWORD_REQUIRED)
            )}
          />
        </FormSection>
      </div>
    )
  }
}


PasswordSection.propTypes = {
  fields: PropTypes.object,
  passwordInputLabel: PropTypes.string,
  linkState: PropTypes.func,
  gtmEvent: PropTypes.func
}

const styles = {
  container: {
    background: '#fff',
    boxSizing: 'content-box',
    maxWidth: '24em',
    margin: '0 auto',
    textAlign: 'left'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  heading: {
    color: '#191919',
    marginBottom: '1em',
    textAlign: 'center'
  }
}

export default withRadium(
  SearchParams({
    exposeParams: ['mymazda', 'register']
  }),
  gtmEvent()
)(MyMazdaPassword)



// WEBPACK FOOTER //
// ./src/components/forms/mymazda/password/index.jsx